import React, { PureComponent } from 'react';
import { wire } from 'react-hot-wire';
import { injectIntl } from 'react-intl';
import { Formik } from 'formik';

import ImportedId from './ImportedId.template';
import { schema } from './ImportedId.schema';
import Register from './register/Register';

export class ImportedIdComponent extends PureComponent {
	_status = null;

	state = {
		suspendedCustomMessage: null,
	};

	constructor(...args) {
		super(...args);

		const urlParams = new URLSearchParams(window.location.search);

		this.identifier = urlParams.get('identifier') || '';
	}

	render() {
		return (
			<Formik
				initialValues={{
					identifier: this.identifier,
				}}
				validationSchema={schema}
				onSubmit={(...args) => this.login(...args)}
				render={props => {
					if (props.status === 'create-account') {
						return <Register integration={this.props.integration} identifier={props.values.identifier} />;
					}

					return <ImportedId {...props} {...this.props} {...this.state} />;
				}}
			/>
		);
	}

	login(values, actions) {
		const { integration } = this.props;

		if (this.state.suspendedCustomMessage) {
			this.setState({ suspendedCustomMessage: null });
		}

		if (values.password) {
			return this.props['services.importedIdIntegrationService']
				.login({
					id: integration.id,
					...values,
				})
				.catch(({ error }) => {
					if (error.messageId === 'user-suspended') {
						const customMessage = this.props['services.applicationService']
							.settings()
							.suspendedUserCustomMessage();

						if (customMessage) {
							this.setState({ suspendedCustomMessage: customMessage });
							actions.setSubmitting(false);
							return;
						}
					}

					actions.setFieldError(
						error.messageId === 'invalid-password' ? 'password' : 'identifier',
						error.messageId
					);
					actions.setSubmitting(false);
				});
		}

		if (!values.password && !integration.annoying && !this._status) {
			return this.props['services.importedIdIntegrationService']
				.check({
					id: integration.id,
					...values,
				})
				.then(response => {
					actions.setStatus(response);
					this._status = response;
				})
				.catch(error => {
					if (error === 'user-not-verified') {
						actions.setStatus('create-account');
					} else {
						actions.setFieldError('identifier', error.message ? error.message : error);
					}
				})
				.finally(() => actions.setSubmitting(false));
		}

		actions.setFieldError('password', 'empty-password');
		actions.setSubmitting(false);
	}
}

export default injectIntl(
	wire(['services.importedIdIntegrationService', 'services.applicationService'], ImportedIdComponent)
);
